import React from 'react';
import { AlertCircle, Trash2 } from 'lucide-react';

interface DeleteDraftModalProps {
    onConfirm: () => Promise<void>;
    onCancel: () => void;
    deleting: boolean;
}

/**
 * Modal for confirming draft deletion
 */
export const DeleteDraftModal: React.FC<DeleteDraftModalProps> = ({
    onConfirm,
    onCancel,
    deleting
}) => {
    const handleConfirm = async () => {
        await onConfirm();
    };

    return (
        <>
            <div
                className="modal show d-block"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                onMouseDown={(e) => {
                    if (e.target === e.currentTarget && !deleting) {
                        onCancel();
                    }
                }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                <AlertCircle size={20} className="me-2 text-danger" />
                                Bekräfta radering
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onCancel}
                                aria-label="Stäng"
                                disabled={deleting}
                            />
                        </div>
                        <div className="modal-body">
                            <p>Är du säker på att du vill radera detta utkast?</p>
                            <p className="text-muted mb-0">Denna åtgärd kan inte ångras.</p>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={onCancel}
                                disabled={deleting}
                            >
                                Avbryt
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={handleConfirm}
                                disabled={deleting}
                            >
                                {deleting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Raderar...
                                    </>
                                ) : (
                                    <>
                                        <Trash2 size={16} className="me-2" />
                                        Radera utkast
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
};
